/* eslint-disable jira/filename-case */
export const parseExtensionId = (
	extensionId: string,
): {
	appId: string;
	envId: string;
} => {
	const [, appId, envId] = extensionId.split('/');
	return {
		appId,
		envId,
	};
};

export const getSameEnvAppIdFromExtensionId = (extensionId: string): string =>
	extensionId.split('/').slice(1, 3).join('/');
